import {createContext} from "react";
import {initialPublisherLoginObj} from "./PublisherLogin"
import {IPublisherLogins} from "../interfaces/IPublisherLogins";

export const PublisherLoginContext = createContext({
    publisherLogin: initialPublisherLoginObj,
    setPublisherLogin: (publisherLogin: IPublisherLogins) => {}
})

